<template>
  <div>
    <PartnerEdit
      v-if="partnerEditModal.isShowPopup"
      :partnerDetail="partnerEditModal.data"
      :isShowPopup="partnerEditModal.isShowPopup"
      @modalCallBack="partnerModalCallBack"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PartnerEdit from "@/containers/Partner/EditPartner";

export default {
    name: "UpdateThumbnail",
  components: { PartnerEdit },

  data() {
    return {
      partnerEditModal: {
        data: null,
        isShowPopup: false,
      },
    };
  },

  computed: {
    ...mapGetters([
      "getPartnerList",
      "getPartnerOrgIdFromAccessToken"
    ]),
  },

  async mounted() {
    const organisationId = this.getPartnerOrgIdFromAccessToken;

    await this.fetchPartners({
      skip: 0,
      organisation_id: organisationId,
    });

    const currentPartner = this.getPartnerList?.[0];

    this.partnerEditModal.data = currentPartner;
    this.partnerEditModal.isShowPopup = true;
  },

  methods: {
    ...mapActions([
      "fetchPartners",
      "updatePartner"
    ]),

    partnerModalCallBack(action, payload) {
      if (action === false) {
        this.partnerEditModal.isShowPopup = false;
        this.partnerEditModal.data = null;
        this.$router.back(); 
      } 
      else if (action === true) {
        let appendAction = this.updatePartner(payload);

        Promise.all([appendAction]).then((res) => {
          if (res) {
            this.partnerEditModal.isShowPopup = false;
            this.partnerEditModal.data = null;
            this.$router.back();
          }
        });
      }
    },
  },
};
</script>